import React from 'react';
import { Dialog } from '@base-ui/react/dialog';

interface LedgerSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
}

export const LedgerSheet: React.FC<LedgerSheetProps> = ({ open, onOpenChange, title, children }) => (
  <Dialog.Root open={open} onOpenChange={(next) => onOpenChange(next)}>
    <Dialog.Portal>
      <Dialog.Backdrop className="fixed inset-0 z-40 bg-ink/30" />
      <Dialog.Popup className="fixed inset-x-0 bottom-0 z-50 max-h-[85dvh] border-t border-ink bg-paper p-4 pb-6">
        {/* cap-label bakes in the ink-muted color, so promoting the title to full ink needs the important flag */}
        <Dialog.Title className="cap-label !text-ink">{title}</Dialog.Title>
        <div className="mt-3 max-h-[calc(85dvh-4.5rem)] overflow-y-auto">{children}</div>
      </Dialog.Popup>
    </Dialog.Portal>
  </Dialog.Root>
);
